<p-dialog
  class="filters-modal add-user-modal"
  header="Agregar usuario"
  [modal]="true"
  [visible]="visible"
  (visibleChange)="setVisible($event)"
  [style]="{ width: '900px', 'max-width': '95vw' }"
  *ngIf="visible"
>
  <form
    class="create-user-form"
    [formGroup]="createUserForm"
    (ngSubmit)="handlePrimaryAction()"
  >
    <div class="step-tabs">
      <button
        type="button"
        class="step-tab"
        [class.active]="activeStep === 1"
        [disabled]="creating"
        (click)="goToAccessStep()"
      >
        <span>1</span>
        Acceso y perfil
      </button>
      <button
        type="button"
        class="step-tab"
        [class.active]="activeStep === 2"
        [disabled]="creating"
        (click)="goToConfigurationStep()"
      >
        <span>2</span>
        Configuración
      </button>
    </div>

    <div class="create-user-body">
      <ng-container *ngIf="activeStep === 1">
        <div class="form-section">
          <div class="form-section-title">Acceso</div>
          <div class="form-grid access-grid">
            <div class="filter-column" *ngIf="canChooseUserType()">
              <label>Tipo de alta <span class="required-marker">*</span></label>
              <p-dropdown
                [options]="availableUserTypeOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="user_type"
                appendTo="body"
                [disabled]="creating"
              />
            </div>
            <div class="filter-column" *ngIf="canChooseRole()">
              <label>Rol <span class="required-marker">*</span></label>
              <p-dropdown
                [options]="roleOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="role_id"
                appendTo="body"
                [disabled]="creating"
              />
            </div>
            <div class="filter-column">
              <label>Usuario <span class="required-marker">*</span></label>
              <input
                pInputText
                formControlName="username"
                placeholder="Ej: maria.perez"
                [readonly]="creating"
                (keydown)="blockWhitespaceInput($event)"
                (paste)="sanitizeWhitespacePaste($event, 'username')"
              />
              <small class="field-error" *ngIf="hasWhitespace('username')">
                El usuario no puede contener espacios.
              </small>
            </div>
            <div class="filter-column">
              <label>
                Correo electrónico
                <span class="required-marker">*</span>
              </label>
              <input
                pInputText
                formControlName="email"
                placeholder="cliente@dominio.com"
                [readonly]="creating"
                (blur)="onIdentityFieldBlur('email')"
              />
              <small class="field-error" *ngIf="hasInUse('email')">
                Este correo ya está en uso
              </small>
            </div>
            <div class="filter-column" *ngIf="requiresPassword()">
              <label>Contraseña <span class="required-marker">*</span></label>
              <p-password
                formControlName="password"
                [toggleMask]="true"
                [feedback]="false"
                placeholder="Mínimo 6 caracteres"
                [disabled]="creating"
                styleClass="w-full"
                inputStyleClass="w-full"
                (keydown)="blockWhitespaceInput($event)"
                (paste)="sanitizeWhitespacePaste($event, 'password')"
              />
              <small class="field-error" *ngIf="hasWhitespace('password')">
                La contraseña no puede contener espacios.
              </small>
            </div>
            <div class="filter-column" *ngIf="requiresPassword()">
              <label
                >Confirmar contraseña
                <span class="required-marker">*</span></label
              >
              <p-password
                formControlName="confirm_password"
                [toggleMask]="true"
                [feedback]="false"
                placeholder="Repite la contraseña"
                [disabled]="creating"
                styleClass="w-full"
                inputStyleClass="w-full"
                (keydown)="blockWhitespaceInput($event)"
                (paste)="sanitizeWhitespacePaste($event, 'confirm_password')"
              />
              <small
                class="field-error"
                *ngIf="hasWhitespace('confirm_password')"
              >
                La contraseña no puede contener espacios.
              </small>
              <small
                class="field-error"
                *ngIf="passwordsMismatch() && createUserForm.touched"
              >
                Las contraseñas no coinciden.
              </small>
            </div>
          </div>
        </div>

        <div class="form-section" *ngIf="shouldShowProfileSection()">
          <div class="form-section-title">Perfil</div>
          <div class="form-grid">
            <div class="filter-column" *ngIf="!isSubuserCreation() && isAdmin()">
              <label>Cumplimiento</label>
              <p-dropdown
                [options]="complianceStatuses"
                optionLabel="label"
                optionValue="value"
                formControlName="status_compliance"
                appendTo="body"
                [disabled]="creating"
              />
            </div>
            <div
              class="filter-column double"
              *ngIf="isSubuserCreation() && isAdmin()"
            >
              <label>Partner padre</label>
              <p-dropdown
                [options]="partnerParentOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="client_partner_id"
                [showClear]="false"
                [filter]="true"
                filterBy="label"
                placeholder="Selecciona el padre"
                appendTo="body"
                [disabled]="creating"
              />
            </div>
            <div class="filter-column" *ngIf="isSubuserCreation()">
              <label>Validez del end-user token</label>
              <p-dropdown
                [options]="tokenExpDayOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="end_user_token_exp_days"
                appendTo="body"
                [disabled]="creating"
              />
            </div>
            <div class="filter-column checkbox-column" *ngIf="isAdmin()">
              <label>White label</label>
              <p-checkbox
                formControlName="white_label"
                [binary]="true"
                [disabled]="creating"
              />
              <small class="field-hint">
                Excluye a este usuario de propagaciones automáticas.
              </small>
            </div>
            <div class="filter-column checkbox-column" *ngIf="isAdmin()">
              <label>Reliance</label>
              <p-checkbox
                formControlName="reliance_enabled"
                [binary]="true"
                [disabled]="creating"
              />
              <small class="field-hint">
                Este usuario y sus hijos no reciben verificación Sumsub.
              </small>
            </div>
            <div class="filter-column double" *ngIf="isAdmin()">
              <label>Tipo de configuración</label>
              <p-dropdown
                [options]="configurationOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="configuration_type"
                appendTo="body"
                [disabled]="creating"
              />
              <small class="field-hint">{{ configurationDescription }}</small>
            </div>
          </div>
        </div>

        <div class="form-section">
          <div class="form-section-header">
            <div>
              <div class="form-section-title">
                {{
                  isBusinessEntity()
                    ? 'Información de la empresa'
                    : 'Información personal'
                }}
              </div>
              <small class="field-hint">
                Los campos marcados con * son obligatorios para crear el usuario.
                <ng-container *ngIf="!requiresAddress()">
                  La dirección es opcional para administradores/soporte de BO.
                </ng-container>
              </small>
            </div>
          </div>

          <div class="form-grid">
            <div class="filter-column">
              <label>Tipo de persona <span class="required-marker">*</span></label>
              <p-dropdown
                [options]="entityTypeOptions"
                optionLabel="label"
                optionValue="value"
                formControlName="entity_type"
                appendTo="body"
                [disabled]="creating"
              />
            </div>
            <ng-container *ngIf="!isBusinessEntity(); else businessIdentityFields">
              <div class="filter-column">
                <label>Primer nombre <span class="required-marker">*</span></label>
                <input
                  pInputText
                  formControlName="first_name"
                  [readonly]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Segundo nombre (opcional)</label>
                <input
                  pInputText
                  formControlName="middle_name"
                  [readonly]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Primer apellido <span class="required-marker">*</span></label>
                <input
                  pInputText
                  formControlName="surname"
                  [readonly]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Segundo apellido (opcional)</label>
                <input
                  pInputText
                  formControlName="second_surname"
                  [readonly]="creating"
                />
              </div>
            </ng-container>
            <ng-template #businessIdentityFields>
              <div class="filter-column">
                <label>Razón social <span class="required-marker">*</span></label>
                <input
                  pInputText
                  formControlName="company_name"
                  [readonly]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Nombre de la marca (opcional)</label>
                <input pInputText formControlName="brand_name" [readonly]="creating" />
              </div>
              <div class="filter-column">
                <label>Número de registro <span class="required-marker">*</span></label>
                <input
                  pInputText
                  formControlName="company_registration_number"
                  [readonly]="creating"
                  (blur)="onIdentityFieldBlur('company_registration_number')"
                />
                <small
                  class="field-error"
                  *ngIf="hasInUse('company_registration_number')"
                >
                  Este documento ya está en uso
                </small>
              </div>
            </ng-template>
            <ng-container *ngIf="!isBusinessEntity()">
              <div class="filter-column">
                <label>Tipo de documento (opcional)</label>
                <p-dropdown
                  [options]="documentTypeOptions"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="document_type"
                  placeholder="Selecciona el tipo"
                  [showClear]="true"
                  appendTo="body"
                  [disabled]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Número de documento (opcional)</label>
                <input
                  pInputText
                  formControlName="document_number"
                  [readonly]="creating"
                  (blur)="onIdentityFieldBlur('document_number')"
                />
                <small class="field-error" *ngIf="hasInUse('document_number')">
                  Este documento ya está en uso
                </small>
              </div>
            </ng-container>
            <div class="filter-column double">
              <label>
                Dirección 1
                <span class="required-marker" *ngIf="requiresAddress()">*</span>
                <ng-container *ngIf="!requiresAddress()"> (opcional)</ng-container>
              </label>
              <input pInputText formControlName="address_line_1" [readonly]="creating" />
            </div>
            <div class="filter-column double">
              <label>Dirección 2 (opcional)</label>
              <input pInputText formControlName="address_line_2" [readonly]="creating" />
            </div>
            <div class="filter-column">
              <label>
                Ciudad
                <span class="required-marker" *ngIf="requiresAddress()">*</span>
                <ng-container *ngIf="!requiresAddress()"> (opcional)</ng-container>
              </label>
              <input pInputText formControlName="city" [readonly]="creating" />
            </div>
            <div class="filter-column">
              <label>
                Código postal
                <span class="required-marker" *ngIf="requiresAddress()">*</span>
                <ng-container *ngIf="!requiresAddress()"> (opcional)</ng-container>
              </label>
              <input pInputText formControlName="postal_code" [readonly]="creating" />
            </div>
            <div class="filter-column">
              <label>
                Provincia/Estado
                <span class="required-marker" *ngIf="requiresAddress()">*</span>
                <ng-container *ngIf="!requiresAddress()"> (opcional)</ng-container>
              </label>
              <input pInputText formControlName="state" [readonly]="creating" />
            </div>
            <div class="filter-column">
              <label>
                País
                <span class="required-marker" *ngIf="requiresAddress()">*</span>
                <ng-container *ngIf="!requiresAddress()"> (opcional)</ng-container>
              </label>
              <input pInputText formControlName="country" [readonly]="creating" />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="activeStep === 2">
        <div class="form-section">
          <div class="form-section-title">Configuración</div>

          <div class="configuration-summary" *ngIf="!isCustomConfiguration()">
            <i class="pi pi-check-circle"></i>
            <div>
              <strong>Configuración base</strong>
              <span>Usa la configuración predeterminada del sistema.</span>
            </div>
          </div>

          <div
            class="custom-configuration-panel"
            *ngIf="isCustomConfiguration()"
          >
            <div class="custom-configuration-header">
              <strong>Configuración personalizada</strong>
              <span>Crea una configuración nueva solo para este usuario.</span>
            </div>

            <div class="form-grid">
              <div class="filter-column checkbox-column">
                <label>Balance unificado</label>
                <p-checkbox
                  formControlName="joint_balance"
                  [binary]="true"
                  [disabled]="creating"
                />
              </div>
              <div class="filter-column checkbox-column">
                <label>Cashouts de misma moneda</label>
                <p-checkbox
                  formControlName="single_currency"
                  [binary]="true"
                  [disabled]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Fee fijo del servicio</label>
                <p-inputNumber
                  formControlName="fixed_fee"
                  mode="decimal"
                  [maxFractionDigits]="8"
                  [disabled]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Fee % del servicio</label>
                <p-inputNumber
                  formControlName="percentage_fee"
                  mode="decimal"
                  [maxFractionDigits]="8"
                  [disabled]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Monto máximo P2P</label>
                <p-inputNumber
                  formControlName="max_p2p_amount"
                  mode="decimal"
                  [maxFractionDigits]="8"
                  [disabled]="creating"
                />
              </div>
              <div class="filter-column">
                <label>Monto máximo interbancaria</label>
                <p-inputNumber
                  formControlName="max_transfer_amount"
                  mode="decimal"
                  [maxFractionDigits]="8"
                  [disabled]="creating"
                />
              </div>
            </div>

            <div class="providers-block">
              <label>Prioridad de proveedores</label>
              <div class="providers-fields">
                <div
                  class="provider-field"
                  *ngFor="
                    let prov of priorities;
                    let i = index;
                    trackBy: trackByValue
                  "
                >
                  <div class="provider-name">
                    {{ i + 1 }} - {{ userService.getUsernameById(prov) }}
                  </div>
                  <div class="actions">
                    <i
                      class="pi pi-arrow-up"
                      (click)="moveUp(i)"
                      *ngIf="i > 0 && !creating"
                    ></i>
                    <i
                      class="pi pi-arrow-down"
                      (click)="moveDown(i)"
                      *ngIf="i < priorities.length - 1 && !creating"
                    ></i>
                    <i
                      class="pi pi-trash"
                      (click)="removePriority(i)"
                      *ngIf="!creating"
                    ></i>
                  </div>
                </div>
                <div class="empty-prov" *ngIf="!priorities.length">
                  No hay proveedores asignados
                </div>
                <div
                  class="provider-field"
                  (click)="addProviderToPriority()"
                  *ngIf="availableProviders.length && !creating"
                >
                  <div class="provider-name provider-button">
                    <i class="pi pi-plus"></i> Agregar proveedor
                  </div>
                </div>
              </div>
            </div>

            <div class="schedule-block">
              <label class="schedule-label">Horario (UTC)</label>
              <div class="schedule-items">
                <div class="schedule-row" *ngFor="let day of scheduleDays">
                  <label>{{ dayLabels[day.name] }}:</label>
                  <input
                    type="time"
                    pInputText
                    [(ngModel)]="day.from"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="creating"
                  />
                  <span>-</span>
                  <input
                    type="time"
                    pInputText
                    [(ngModel)]="day.to"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="creating"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="modal-footer">
      <p-button
        label="Cancelar"
        severity="danger"
        type="button"
        [disabled]="creating"
        (click)="setVisible(false)"
      />
      <p-button
        label="Volver"
        severity="secondary"
        type="button"
        [outlined]="true"
        [disabled]="creating"
        (click)="goToAccessStep()"
        *ngIf="activeStep === 2"
      />
      <p-button
        [label]="primaryActionLabel"
        icon="pi pi-user-plus"
        severity="secondary"
        type="submit"
        [loading]="creating || checkingUniqueness"
        [disabled]="
          creating ||
          checkingUniqueness ||
          (activeStep === 1 && basicFieldsInvalid()) ||
          (activeStep === 2 && (createUserForm.invalid || hasIdentityInUse())) ||
          (isSubuserCreation() ? !canCreateSubusers() : !canCreateUsers())
        "
      />
    </div>
  </form>
</p-dialog>

<p-dialog
  class="filters-modal add-provider-modal"
  header="Agregar proveedor a la prioridad"
  [modal]="true"
  [(visible)]="addProviderModal"
  [style]="{ width: '400px' }"
  *ngIf="addProviderModal"
>
  <div class="add-provider-container">
    <p-dropdown
      placeholder="Elige un proveedor para agregar"
      [options]="availableProviders"
      optionLabel="username"
      [filter]="true"
      filterBy="username"
      [(ngModel)]="selectedProvider"
    />
  </div>
  <div class="buttons-container">
    <p-button
      label="Cancelar"
      severity="danger"
      (click)="addProviderModal = false"
    />
    <p-button
      label="Agregar proveedor"
      severity="secondary"
      (click)="addProviderToPriorityConfirmed()"
    />
  </div>
</p-dialog>
